import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import DottedLoading from "../DottedLoading/DottedLoading";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  deleteType,
  itemId,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true); // Start loading
    try {
      await onConfirm(); // Call the onConfirm function (API call)
    } finally {
      setIsLoading(false); // Stop loading after API response
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <style>
        {`
          .delete-icon-animated {
            display: block;
            margin: 0 auto 1.5rem;
            animation: shake 0.5s ease-in-out infinite alternate;
          }
          @keyframes shake {
            0% { transform: scale(1); }
            100% { transform: scale(1.1); }
          }
        `}
      </style>
      <Modal.Header closeButton>
        <Modal.Title className="ah-heading-06 fw-semibold modal-title h4">
          Confirm Deletion
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="delete-icon-animated"
          aria-label="Animated delete icon"
        >
          <path
            d="M6 7H5V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V7H6Z"
            stroke="#F05203"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 10V17M14 10V17M8 7V5C8 4.44772 8.44772 4 9 4H15C15.5523 4 16 4.44772 16 5V7"
            stroke="#F05203"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4 7H20"
            stroke="#F05203"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <p className="ah-text-lg fw-semibold text-gray-600">Do you want to delete {deleteType}?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? <DottedLoading /> : "Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
